import React, { useState } from "react";
import "../../assets/css/responsive.css";
import "../../assets/css/style.css";
import "../../assets/css/hamburger.css";
import NavBar from "../../components/general/NavBarApp";
import AcceptedMissionNotification from "../../components/general/AcceptedMissionNotification";
import Footer from "../../components/general/footer";

const MentionLegal = () => {
  return (
    <div className="main">
      <NavBar userType="interim" />
      <AcceptedMissionNotification />
    </div>
  );
};

export default MentionLegal;
